import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=090be4c4&"
import script from "./BaseLayout.vue?vue&type=script&lang=ts&"
export * from "./BaseLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports